<template>

  <div>
    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :blank-data="blankData"
      @refetch-data="refetchData"
      @input="showAddEditUsuario"
    />

    <!-- Filters -->
    <users-list-filters
      v-if="false"
      :filters="{
        dataInicioValidadeFilter: dataInicioValidadeFilter,
        dataTerminoValidadeFilter: dataTerminoValidadeFilter,
      }"
      @updateFilters="updateFilters"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                v-if="$can('create', 'Vendedor')"
                variant="primary"
                @click="createTabelaPreco"
              >

                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="PlusIcon"
                    size="16"
                  />
                  Tabela de Preço
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refTabelaprecoTable"
        class="position-relative"
        :items="findAllTabelaPreco"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #head(actions)="data">
          <span style="display: flex;justify-content: end">{{ data.label }}</span>
        </template>

        <template #head(total_produto)="data">
          <span style="display: flex;justify-content: center">{{ data.label }}</span>
        </template>

        <template #cell(data_inicio_validade)="data">
          {{ data.item.data_inicio_validade | formatDateBr }}
        </template>

        <!-- Column: data_inclusao -->
        <template #cell(data_inclusao)="data">
          <span class="text-nowrap">{{ data.item.data_inclusao | formatDateTimeBr }}</span>
        </template>

        <!-- Column: data_inclusao -->
        <template #cell(total_produto)="data">
          <div class="text-center">

            <span class="text-nowrap text-center">{{ data.item.tabela_preco_itens.length }}</span>
          </div>
        </template>

        <template #cell(data_termino_validade)="data">
          {{ data.item.data_termino_validade | formatDateBr }}
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px; flex-wrap: nowrap"
          >
            <feather-icon
              v-if="$can('create', 'Vendedor')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Adicionar preço no produto'"
              style="color: var(--success);"
              size="20"
              class="icon-activity"
              icon="PlusSquareIcon"
              @click.stop="addItemTabelaPreco(data.item.id)"
            />
            <feather-icon
              v-if="$can('update', 'Vendedor')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Editar'"
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editarTabelaPreco(data.item.id)"
            />
            <feather-icon
              v-if="$can('delete', 'Vendedor')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Deletar'"
              v-b-modal.modal-confirme-delete-grupo
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="idTabelaPreco = data.item.id"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalTabelaPreco"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-grupo"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir o grupo?"
      @ok="deletedGrupo"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BPagination, VBModal, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onUnmounted, onMounted,
} from '@vue/composition-api'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import { formatDateBr, avatarText, formatDateTimeBr } from '@/@core/utils/filter'
import router from '@/router'
import UsersListFilters from './TabelaPrecoListFilters.vue'
import tabelaPrecoStoreModule from './tabelaPrecoStoreModule'
import UserListAddNew from './TabelaPrecoListAddNew.vue'
import useTabelaPrecoList from './useTabelaPrecoList'

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    ModalConfirm,
    vSelect,
  },
  filters: {
    avatarText,
    formatDateBr,
    formatDateTimeBr,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const toast = useToast()
    const USER_APP_STORE_MODULE_NAME = 'appTabelaPreco'
    const blankData = ref({
      id: null,
      descricao: '',
      data_inicio_validade: null,
      data_termino_validade: null,
    })
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, tabelaPrecoStoreModule)
    const gruposOptions = ref([])
    onMounted(() => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/findAllTabelaPreco`)
    })

    const updateFilters = e => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/findAllTabelaPreco`)
    }
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const createTabelaPreco = async () => {
      blankData.value = {
        id: null,
        descricao: '',
        data_inicio_validade: null,
        data_termino_validade: null,
      }
      isAddNewUserSidebarActive.value = true
    }

    const editarTabelaPreco = async tabelaPrecoId => {
      await store.dispatch(`${USER_APP_STORE_MODULE_NAME}/updatedTabelaPreco`, { id: tabelaPrecoId })
        .then(data => {
          blankData.value = data.data
          isAddNewUserSidebarActive.value = true
        })
    }

    const addItemTabelaPreco = async tabelaPrecoId => {
      router.push({ name: 'app-admin-tabela-precos-add-item', params: { id: tabelaPrecoId } })
    }

    const statusOptions = [
      { label: 'Todos', value: '' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const {
      findAllTabelaPreco,
      tableColumns,
      perPage,
      currentPage,
      totalTabelaPreco,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTabelaprecoTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      dataInicioValidadeFilter,
      dataTerminoValidadeFilter,
    } = useTabelaPrecoList()
    const idTabelaPreco = ref(null)
    const deletedGrupo = async () => {
      await store.dispatch(`${USER_APP_STORE_MODULE_NAME}/deleteTabelaPrecoById`, { id: idTabelaPreco.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idTabelaPreco.value = null
          refetchData()
        })

      refetchData()
    }
    return {
      idTabelaPreco,
      createTabelaPreco,
      blankData,
      editarTabelaPreco,
      addItemTabelaPreco,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      findAllTabelaPreco,
      tableColumns,
      perPage,
      currentPage,
      totalTabelaPreco,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTabelaprecoTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      statusOptions,

      // Extra Filters
      roleFilter,
      grupoFilter,
      dataInicioValidadeFilter,
      dataTerminoValidadeFilter,
      updateFilters,
      deletedGrupo,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
